import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { toast } from 'sonner';
import { useApp } from '@/contexts/AppContext';
import { useTranslated } from '@/hooks/useTranslated';
import AuthenticatedBadge from './AuthenticatedBadge';

export default function ProductCard({ product }) {
  const { user, api } = useApp();
  const navigate = useNavigate();
  const img = (product.images || [])[0];
  const [title] = useTranslated([product.title], `prod:${product.id}:title`);

  const onWish = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) { navigate('/login'); return; }
    try { await api.post(`/wishlist/${product.id}`); toast.success('Saved to wishlist'); }
    catch { toast.error('Could not save'); }
  };

  return (
    <Link to={`/product/${product.id}`} className="group block relative" data-testid={`product-card-${product.id}`}>
      <div className="overflow-hidden bg-muted aspect-[4/5] relative">
        {img && <img src={img} alt={product.title} loading="lazy" className="w-full h-full object-cover ken-burns" />}
        <div className="absolute top-3 left-3"><AuthenticatedBadge /></div>
        <button onClick={onWish} className="absolute top-3 right-3 bg-white/85 backdrop-blur p-2 hover:bg-white transition" aria-label="wishlist" data-testid={`card-wish-${product.id}`}>
          <Heart size={14} strokeWidth={1.4} />
        </button>
      </div>
      <div className="pt-4">
        <div className="overline text-muted-foreground">{product.designer}</div>
        <div className="mt-1 font-display text-base leading-snug line-clamp-2" data-testid={`product-title-${product.id}`}>{title}</div>
        <div className="mt-2 flex items-baseline gap-3">
          <span className="text-base font-medium" data-testid={`product-price-${product.id}`}>${Number(product.price).toLocaleString()}</span>
          {product.original_price && product.original_price > product.price && (
            <span className="text-xs text-muted-foreground line-through">${Number(product.original_price).toLocaleString()}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
